import { useEffect, useState } from "react";
import useRequest from "./use-req";

const normalizeDialCode = (code: string | number) => {
  const str = String(code);
  return str.startsWith("+") ? str : `+${str}`;
};

// GET /auth/get_userdata → payload.country_code — defaults a phone input's
// dial code to the logged-in user's own country/location instead of
// hardcoding one (e.g. Nigeria) for everyone; the caller still renders its
// own dropdown so the user can pick a different country code.
export default function useDefaultCountryCode(fallback = "+234") {
  const token = localStorage.getItem("authToken");
  const [defaultCountryCode, setDefaultCountryCode] = useState(fallback);
  const { makeRequest: getCurrentUser } = useRequest("/auth/get_userdata", "GET", {
    Authorization: `Bearer ${token}`,
  });

  useEffect(() => {
    (async () => {
      const [response] = await getCurrentUser();
      const code = response?.payload?.country_code;
      if (code) setDefaultCountryCode(normalizeDialCode(code));
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return defaultCountryCode;
}
